export default __webpack_public_path__ + "static/fax-papers-8ae6983ee2b4d7e511c749aad4cb713d.png";